export default __webpack_public_path__ + "static/media/item4.6cba0907.svg";